/**
 * Layout-only parent route for /followups/*.
 *
 * In TanStack Router file-based routing, every parent in the chain
 * must render `<Outlet />` for nested children to mount. The list page
 * itself lives in `_app.followups.index.tsx`; this file just renders
 * the outlet so child routes (`/followups/trash`) can mount under
 * `_app/followups`.
 *
 * Same shape as `_app.deals.tsx`, `_app.contacts.tsx`, and
 * `_app.accounts.tsx` — keep them in sync.
 */
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/followups")({
  component: FollowupsLayout,
});

function FollowupsLayout() {
  return <Outlet />;
}
